function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef } from "react";
import { Container } from "react-bootstrap";
import { Image, Row, Col, Alert, Space, Table } from "antd";
import { GeoAltFill, TelephoneFill, Globe, Bank2, EnvelopeAtFill } from "react-bootstrap-icons";
import { NumberToLetter } from 'convertir-nombre-lettre';
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BillConfirm = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$candidates = _ref.candidates,
    candidates = _ref$candidates === void 0 ? [] : _ref$candidates,
    company = _ref.company,
    from = _ref.from,
    to = _ref.to,
    setAmount = _ref.setAmount,
    setCurCompany = _ref.setCurCompany,
    handler = _ref.handler;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    a1Array = _useState2[0],
    setA1Array = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    a2Array = _useState4[0],
    setA2Array = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    b1Array = _useState6[0],
    setB1Array = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    b2Array = _useState8[0],
    setB2Array = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    b3Array = _useState0[0],
    setB3Array = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    b4Array = _useState10[0],
    setB4Array = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    b5Array = _useState12[0],
    setB5Array = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    arData = _useState14[0],
    setArData = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    peArray = _useState16[0],
    setPeArray = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    vaArray = _useState18[0],
    setVaArray = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    dayArray = _useState20[0],
    setDayArray = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    ptArray = _useState22[0],
    setPtArray = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    woVaccinArray = _useState24[0],
    setWoVaccinArray = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    woRadioArray = _useState26[0],
    setWeRadioArray = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    woSpiroArray = _useState28[0],
    setWoSpiroArray = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    woEcgArray = _useState30[0],
    setWoEcgArray = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    woAsatArray = _useState32[0],
    setWoAsatArray = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    woCreatinineArray = _useState34[0],
    setWoCreatinineArray = _useState34[1];
  var _useState35 = useState(0),
    _useState36 = _slicedToArray(_useState35, 2),
    totalAmount = _useState36[0],
    setTotalAmount = _useState36[1];
  var cols = [{
    title: "Désignation",
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: "Qte",
    dataIndex: "quantity",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "quantity"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "amount"
  }];
  var itemsPrice = {
    physical_exam: 160000,
    parasitology: 25000,
    coproculture: 350000,
    urine: 160000,
    nfs: 100000,
    glycemia: 20000,
    drug_test: 300000,
    hba1c: 300000,
    visio_test: 100000,
    audio_test: 150000,
    spiro: 150000,
    crp: 50000,
    cholesterol: 150000,
    triglyceride: 50000,
    vs: 60000,
    aghbs: 25000,
    radio: 130000,
    ecg: 120000,
    tb: 20000,
    asat: 80000,
    uree_creatine: 50000,
    creatine: 50000,
    yellow_fever: 120000,
    polio: 100000,
    typhoid: 120000,
    hepatite_a: 900000,
    hepatite_b: 750000
  };
  var priceScheme = [{
    category: "an",
    price: 2350000
  }, {
    category: "pe",
    price: 2350000
  }, {
    category: "day",
    price: 500000
  }, {
    category: "wp",
    price: 500000
  }, {
    category: "A1",
    price: 640000
  }, {
    category: "A2",
    price: 540000
  }, {
    category: "B1",
    price: 1185000
  }, {
    category: "B2",
    price: 1295000
  }, {
    category: "B3",
    price: 695000
  }, {
    category: "B4",
    price: 3105000
  }, {
    category: "B5",
    price: 2530000
  }];
  useEffect(function () {
    var ta = 0;
    setCurCompany(company);
    candidates.forEach(function (c) {
      /*if(c.medecine_questions != null && c.medecine_questions != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.parasitology != null && c.laboratory_result.parasitology != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.urine != null && c.laboratory_result.urine != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.drug_test != null && c.laboratory_result.drug_test != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.drug_test != null && c.laboratory_result.drug_test != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.hemato != null && c.laboratory_result.hemato != 'undefined' && c.laboratory_result.hemato.crp != null) {
          
      }
      if(c.laboratory_result && c.laboratory_result.hemato != null && c.laboratory_result.hemato != 'undefined') {
          
      }
      if(c.laboratory_result && c.laboratory_result.biochimie != null && c.laboratory_result.biochimie.glycemie != 'undefined' && c.laboratory_result.biochimie.glycemie != null) {
          
      }
      if(c.laboratory_result && c.laboratory_result.biochimie != null && c.laboratory_result.biochimie.glycemie != 'undefined' && c.laboratory_result.biochimie.glycemie != null) {
          
      }
      if(c.laboratory_result && c.laboratory_result.hemato != null && c.laboratory_result.hemato != 'undefined' && c.laboratory_result.hemato.hba1c != null) {
          
      }
      if(c.visio_test != null && c.visio_test != 'undefined') {
           
      }
      if(c.spirometrie  != null && c.spirometrie  != 'undefined') {
       }
      if(c.laboratory_result && c.laboratory_result.biochimie != null && c.laboratory_result.biochimie != 'undefined' && c.laboratory_result.biochimie.cholesterol_t != null) {
          
      }
      if(c.laboratory_result && c.laboratory_result.serology != null && c.laboratory_result.serology != 'undefined' && c.laboratory_result.serology.aghbs != null) {
          
      }
      if(c.im_result && c.im_result != null && c.im_result != 'undefined') {
          
      }
      if(c.ecg && c.ecg != null && c.ecg != 'undefined') {
          
      }
      if(c.laboratory_result && c.laboratory_result.biochimie != null && c.laboratory_result.biochimie != 'undefined' && c.laboratory_result.biochimie.uree != null) {
          
      }
      if(c.laboratory_result && c.laboratory_result.biochimie != null && c.laboratory_result.biochimie != 'undefined' && c.laboratory_result.biochimie.creatinemie != null) {
          
      }
      if(c.vaccin_process && c.vaccin_process != null && c.vaccin_process != 'undefined' && c.vaccin_process.first_dose_yf != null) {
          
      }
      if(c.vaccin_process && c.vaccin_process != null && c.vaccin_process != 'undefined' && c.vaccin_process.first_dose_bvac != null) {
          
      }
      if(c.vaccin_process && c.vaccin_process != null && c.vaccin_process != 'undefined' && c.vaccin_process.first_dose_typhoid != null) {
          
      } */
      if (c.category == "0") {
        if (c.reason == "0") {
          ta += priceScheme.filter(function (s) {
            return s.category == "an";
          })[0].price;
          setVaArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              candidate: c,
              amount: ta
            }]);
          });
          return;
        }
        if (c.reason == "1") {
          setPeArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == "pe";
          })[0].price;
          return;
        }
        if (c.reason == "2") {
          setDayArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == "day";
          })[0].price;
          return;
        }
        if (c.reason == "3") {
          setPtArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == "wp";
          })[0].price;
          return;
        }
      }
      if (c.category == "A1") {
        setA1Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "A1";
        })[0].price;
        return;
      }
      if (c.category == "A2") {
        setA2Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "A2";
        })[0].price;
        return;
      }
      if (c.category == "B1") {
        setB1Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B1";
        })[0].price;
        return;
      }
      if (c.category == "B2") {
        setB2Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B2";
        })[0].price;
        return;
      }
      if (c.category == "B3") {
        setB3Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B3";
        })[0].price;
        return;
      }
      if (c.category == "B4") {
        setB4Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B4";
        })[0].price;
        return;
      }
      if (c.category == "B5") {
        setB5Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B5";
        })[0].price;
        return;
      }
    });
    setTotalAmount(ta);
    setAmount(ta);
  }, []);
  useEffect(function () {
    if (vaArray.length > 0) {
      alert("va");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales annuelles",
          quantity: vaArray.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "an";
          })[0].price * vaArray.length).toLocaleString("Fr")
        }]);
      });
    }
    if (peArray.length > 0) {
      alert("pe");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales de pre-ambauche",
          quantity: peArray.length.toLocaleString("fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "pe";
          })[0].price * peArray.length).toLocaleString("Fr")
        }]);
      });
    }
    if (dayArray.length > 0) {
      alert("day");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales de travailleurs journaliers",
          quantity: dayArray.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "day";
          })[0].price * dayArray.length).toLocaleString("Fr")
        }]);
      });
    }
    if (ptArray.length > 0) {
      alert("wp");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales permis de travail",
          quantity: ptArray.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "wp";
          })[0].price * ptArray.length).toLocaleString("Fr")
        }]);
      });
    }
    if (a1Array.length > 0) {
      alert("a1");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type A1",
          quantity: a1Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "A1";
          })[0].price * a1Array.length).toLocaleString("Fr")
        }]);
      });
    }
    if (a2Array.length > 0) {
      alert("a2");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type A2",
          quantity: a2Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "A2";
          })[0].price * a2Array.length).toLocaleString("Fr")
        }]);
      });
    }
    if (b1Array.length > 0) {
      alert("b1");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type B1",
          quantity: b1Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "B1";
          })[0].price * b1Array.length).toLocaleString("Fr")
        }]);
      });
    }
    if (b2Array.length > 0) {
      alert("b2");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type B2",
          quantity: b2Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "B2";
          })[0].price * b2Array.length).toLocaleString("Fr")
        }]);
      });
    }
    if (b3Array.length > 0) {
      alert("b3");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type B3",
          quantity: b3Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "B3";
          })[0].price * b3Array.length).toLocaleString("Fr")
        }]);
      });
    }
    if (b4Array.length > 0) {
      alert("b4");
      setArData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          label: "Visites médicales type B4",
          quantity: b4Array.length.toLocaleString("Fr"),
          amount: (priceScheme.filter(function (s) {
            return s.category == "B4";
          })[0].price * b4Array.length).toLocaleString("Fr")
        }]);
      });
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    id: "printable",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 9,
            offset: 15
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#FFF",
              borderRadius: "5px",
              padding: "22px",
              border: "2px dashed #A9675C"
            },
            children: [/*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "/drawables/emgl.png",
              width: "190px"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GeoAltFill, {
                  size: 17
                }), " "]
              }), " Conakry, Kip\xE9 - Kaporo, Rep. Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TelephoneFill, {
                size: 17
              }), " + 224-621 724921 ", /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx(Globe, {
                size: 17
              }), " www.medviegn.com"]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#F3F2EE",
              borderRadius: "5px",
              padding: "13px",
              boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
            },
            children: [/*#__PURE__*/_jsx("b", {
              children: "INFOS CLIENT"
            }), /*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                children: company.label
              })
            }), /*#__PURE__*/_jsxs("b", {
              children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
                date: from,
                format: "DD/MM/YYYY"
              }), " au ", /*#__PURE__*/_jsx(Moment, {
                date: to,
                format: "DD/MM/YYYY"
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: {
            span: 20,
            offset: 4
          },
          children: [/*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            sticky: true,
            dataSource: arData,
            pagination: false
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL (GNF) : "
            }), " ", totalAmount.toLocaleString("Fr")]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("b", {
              style: {
                fontStyle: "italic"
              },
              children: ["Arr\xEAt\xE9e la pr\xE9sente facture \xE0 la somme de ", NumberToLetter(totalAmount), " Francs Guin\xE9ens"]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              lg: {
                span: 10,
                offset: 14
              },
              children: [/*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "La comptabilit\xE9"
                })
              }), /*#__PURE__*/_jsx(Image, {
                src: "/drawables/compsign.png",
                preview: false,
                width: "250px"
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#F3F2EE",
              borderRadius: "5px",
              padding: "6px",
              boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("b", {
                children: "MEDVIE SARLU, "
              }), /*#__PURE__*/_jsx(GeoAltFill, {
                size: "16"
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "Conakry - Kip\xE9"
              }), /*#__PURE__*/_jsx(EnvelopeAtFill, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "info@centremedvie.com"
              }), /*#__PURE__*/_jsx(TelephoneFill, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "+224-621 724921"
              }), /*#__PURE__*/_jsx(Globe, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "www.medviegn.com"
              }), /*#__PURE__*/_jsx(Bank2, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "N\xBACompte"
              }), /*#__PURE__*/_jsx("b", {
                children: "0395090903909502 ECOGN"
              })]
            })
          })
        })
      })]
    })
  });
});
export default BillConfirm;